import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Tag } from 'lucide-react';

const ProductCard = ({ product }) => {
  const finalPrice = product.discount > 0
    ? product.price * (1 - product.discount / 100)
    : product.price;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/product/${product.id}`} className="group block">
        <div className="relative aspect-[3/4] rounded-2xl overflow-hidden mb-4 bg-muted">
          <img
            src={product.image_url}
            alt={product.name}
            className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-700"
            loading="lazy"
          />
          {product.discount > 0 && (
            <div className="absolute top-4 right-4 bg-accent text-white px-3 py-1 rounded-full flex items-center gap-1 text-sm font-medium">
              <Tag className="h-3 w-3" />
              -{product.discount}%
            </div>
          )}
        </div>

        <div>
          <h3 className="font-body text-lg font-medium text-foreground mb-2 group-hover:text-primary transition-colors">
            {product.name}
          </h3>
          <div className="flex items-center gap-2">
            {product.discount > 0 ? (
              <>
                <span className="text-lg font-semibold text-foreground">
                  {finalPrice.toFixed(2).replace('.', ',')} €
                </span>
                <span className="text-sm text-muted-foreground line-through">
                  {product.price.toFixed(2).replace('.', ',')} €
                </span>
              </>
            ) : (
              <span className="text-lg font-semibold text-foreground">
                {product.price.toFixed(2).replace('.', ',')} €
              </span>
            )}
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;